import * as angular from 'angular';
import CellularDeviceSelectorModule from './cellularDeviceSelector/sub-module';
import ComponentModule from './components/sub-module';
import DecoratorModule from './decorators/sub-module';
import DialogModule from './dialog/sub-module';
import DirectiveModule from './directives/sub-module';
import FilterModule from './filters/sub-module';
import FormatAddressModule from './formatAddress/sub-module';
import LayoutPaddingModule from './layoutPadding/sub-module';
import LocationInformationModule from './locationInformation/sub-module';
import PowerBiClientModule from './powerBiClient/sub-module';
import ValidationModule from './validation/sub-module';
import VirtualRepeaterModule from './virtualRepeater/sub-module';

export const sharedRequires = [
    'ngMaterial',
    'cas.dynamicElement',
    'casLinkThemeColors',
    CellularDeviceSelectorModule,
    ComponentModule,
    DecoratorModule,
    DialogModule,
    DirectiveModule,
    FilterModule,
    FormatAddressModule,
    LayoutPaddingModule,
    LocationInformationModule,
    PowerBiClientModule,
    ValidationModule,
    VirtualRepeaterModule,
];

export function SetConstants(module: angular.IModule) {
    module
        // tslint:disable-next-line: no-magic-numbers
        .constant('secondsInDay', 24 * 60 * 60)
        .constant('dateFormat', 'MM/DD/YYYY hh:mm:ss A');
}
